// Mock data for ICE Ingeniería Civil Especializada

export const brand = {
  name: 'ICE',
  full: 'Ingeniería Civil Especializada',
  since: '1972',
  logoColor: '/images/logoColor.png',
  logoWhite: '/images/logoWhite.png',
};

export const hero = {
  eyebrow: 'Desde 1972',
  words: ['Construimos', 'infraestructura', 'que conecta', 'a México'],
  subtitle: 'Más de 50 años transformando la visión técnica en obra de alto impacto.',
  image: '/images/hero_image.jpg',
  secondaryImage: '/images/hero_secondaryImage.jpg',
};

export const about = {
  kicker: 'Quiénes Somos',
  title: 'Empresa Administradora & Gerencial',
  body: 'Desarrollamos proyectos de ingeniería desde su conceptualización hasta la ejecución, con soluciones técnicas de alto nivel.',
  body2: 'Estudios geológicos, geotécnicos, geofísicos, topografía, fotogrametría, batimetría e hidráulicos como base para cada decisión.',
  values: ['Honestidad', 'Compromiso', 'Profesionalismo', 'Trabajo en equipo', 'Responsabilidad', 'Eficiencia'],
  image: '/images/about_image.jpg',
  imageEngineers: '/images/about_imageEngineers.jpg',
  imageTexture: '/images/about_imageTexture.jpg',
  mission: 'Lograr la satisfacción de nuestros clientes con los más altos estándares de calidad, seguridad y servicio.',
  philosophy: 'Cada proyecto es una oportunidad de demostrar que la ingeniería puede ser precisa, eficiente y humana al mismo tiempo.',
};

export const stats = [
  { value: '50', suffix: '+', label: 'Años de experiencia' },
  { value: '200', suffix: '+', label: 'Proyectos entregados' },
  { value: '40', suffix: 'km', label: 'Vialidades construidas' },
  { value: '14', suffix: '', label: 'Clientes institucionales' },
];

export const parallaxBands = {
  bridge: '/images/parallax_bridge.jpg',
  aerial: '/images/parallax_aerial.jpg',
};

export const services = [
  { id: '01', title: 'Obras de Electrificación', desc: 'Baja y media tensión para desarrollos urbanos, industriales y comerciales.' },
  { id: '02', title: 'Obras de Edificación', desc: 'Edificación horizontal y vertical, arquitectura y obras civiles a nivel ejecutivo.' },
  { id: '03', title: 'Obras Hidráulicas y Pluviales', desc: 'Sistemas hidráulicos, pluviales, plantas de tratamiento y desalinización.' },
  { id: '04', title: 'Vías Terrestres', desc: 'Carreteras, autopistas, pavimentos y movimientos de tierra de alta complejidad.' },
  { id: '05', title: 'Equipamiento Urbano', desc: 'Urbanización y obra civil con enfoque en calidad de vida y funcionalidad.' },
  { id: '06', title: 'Instalaciones Industriales', desc: 'Instalaciones industriales, comerciales y suministro de materiales.' },
];

export const projects = [
  { title: 'Acuario Mar de Cortés', category: 'Obras Civiles · Mazatlán, Sinaloa', desc: 'Obra de referencia turística y arquitectónica para el Pacífico mexicano.', tags: ['Edificación', 'Obra Civil'], image: '/images/project_1.jpg' },
  { title: 'Autopista Tepic–San Blas', category: 'Vías Terrestres · Nayarit', desc: '4 km de autopista con entronque Matanchen sobre terreno de alta complejidad.', tags: ['Autopista', 'SCT'], image: '/images/project_2.jpg' },
  { title: 'Puente San Nicolás', category: 'Vías Terrestres · Querétaro', desc: 'Obra de infraestructura vial de alto impacto regional.', tags: ['Puente', 'Vialidad'], image: '/images/project_3.jpg' },
  { title: 'Planta Desalinizadora 40 L.P.S.', category: 'Hidráulica · Riviera Nayarit', desc: 'Reequipamiento de planta desalinizadora por osmosis inversa.', tags: ['Desalinización', 'Hidráulica'], image: '/images/project_4.jpg' },
  { title: 'Vialidades Costa Pacífico', category: 'Urbanización · 40.65 km', desc: 'Vialidades con electrificación, alumbrado, agua, drenaje y telefonía.', tags: ['Urbanización', 'Infraestructura'], image: '/images/project_5.jpg' },
  { title: 'Recinto Portuario Topolobampo', category: 'Portuario · Sinaloa', desc: 'Escala náutica, marina seca, muelle flotante y estación de combustible.', tags: ['Marina', 'Portuario'], image: '/images/project_6.jpg' },
];

export const specialties = [
  { title: 'Topografía y Fotogrametría', desc: 'Levantamientos de precisión y drones aéreos.' },
  { title: 'Estudios Batimétricos', desc: 'Caracterización de fondo marino y lacustre.' },
  { title: 'Estudios Geotécnicos', desc: 'Análisis de subsuelo para cimentaciones seguras.' },
  { title: 'Hidrología e Hidráulica', desc: 'Cuencas, escurrimientos y obras de drenaje.' },
  { title: 'Proyecto Geométrico', desc: 'Alineamientos para carreteras y vialidades.' },
  { title: 'Proyectos de Urbanización', desc: 'Fraccionamientos y parques industriales.' },
  { title: 'Supervisión de Obra', desc: 'Control de calidad, costos y programas.' },
  { title: 'Planeación y Control', desc: 'Gestión BIM, presupuestos y avance.' },
];

export const clients = [
  'Gobierno de Sinaloa', 'SECTUR', 'Acuario Mar de Cortés', 'Grupo Andrade',
  'Hospital San José', 'SCT', 'Mota-Engil', 'IDINSA',
  'Costa Canuva', 'Higuera Golf Club', 'Gobierno de Nayarit', 'Querétaro',
  'Heraldo Media Group', 'Cúbica',
];

export const contact = {
  email: 'gerencia@ice-ingenieria.com',
  phone: '(669) 110 00 96',
  phoneTel: '+526691100096',
  address: 'Av. Del Delfín No. 6234, Marina Mazatlán, Sinaloa',
  founded: '1972',
};

export const serviceOptions = [
  'Obras Civiles y Urbanización',
  'Vías Terrestres y Carreteras',
  'Proyectos de Edificación',
  'Obras Hidráulicas y Pluviales',
  'Instalaciones Industriales/Comerciales',
  'Estudios de Ingeniería',
  'Supervisión de Obra',
  'Otro',
];

